import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {IWalkOfShameGameData, IWalkOfShameInitData} from "./data/IWalkOfShameData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {WalkOfShameParsedInitData} from "./data/WalkOfShameParsedInitData";
import {WalkOfShameParsedGameData} from "./data/WalkOfShameParsedGameData";
import {WalkOfShameDataParser} from "./data/WalkOfShameDataParser";
import {WalkOfShame} from "../WalkOfShame";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {WalkOfShameGameConfig} from "../WalkOfShameGameConfig";

export class WalkOfShameModel extends GameModel<IWalkOfShameInitData, IWalkOfShameGameData> {

    public parsedInitData: WalkOfShameParsedInitData;
    public parsedGameData: WalkOfShameParsedGameData;
    public reels: string[][];
    public isRestore: boolean = false;
    public isRestoreFeatureBet: boolean;
    public buyFeatureName: string;
    public fsLeftCtr: number = -1;

    private readonly _parser: WalkOfShameDataParser;

    constructor(api: ApiPlugin, triggerEvents: boolean = true) {
        super(api, triggerEvents);
        api.events.once("featureBet", (data: boolean) => {
            this.isRestoreFeatureBet = data;
        });
        api.events.once("featureName", (data: string) => {
            this.buyFeatureName = data;
        });
        WalkOfShame.apiPlugin.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
            // #65
            WalkOfShameGameConfig.IS_LUCKY_DRAW = (betData.featureName === "LUCKY_DRAW");

            for (let index: number = 0; index < WalkOfShame.model.initData.featureBuyTimesBetValue.length; index++) {
                if (WalkOfShame.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });
        WalkOfShame.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            // #65
            WalkOfShameGameConfig.IS_LUCKY_DRAW = (betData.featureName === "LUCKY_DRAW");

            for (let index: number = 0; index < WalkOfShame.model.initData.featureBuyTimesBetValue.length; index++) {
                if (WalkOfShame.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });
        this._parser = new WalkOfShameDataParser();
    }

    public onGame(data: IWalkOfShameGameData): void {
        this.parsedGameData = new WalkOfShameParsedGameData(data, this._parser);
        this.reels = this.parsedGameData.reels;
        this.isRestore = false;
        super.onGame(data);
    }

    protected onInit(data: IWalkOfShameInitData): void {
        this.parsedInitData = new WalkOfShameParsedInitData(data, this._parser);
        this.reels = this.parsedInitData.reels;
        this.isRestore = data.isRestoreState;
        super.onInit(data);
    }
}